import { getTeamColor } from './teamColors';
import { Tooltip } from './Tooltip';
import { teamOwnersLabel } from './teamOwnersLabel';

interface TeamPillProps {
    team: string;
    size?: 'sm' | 'xs';
}

export function TeamPill({ team, size = 'sm' }: TeamPillProps) {
    const isXs = size === 'xs';
    return (
        <div
            className={`inline-flex items-center justify-center gap-1.5 rounded-md font-semibold text-white ${
                isXs ? 'text-[10px] px-2 py-0.5 gap-1' : 'text-xs px-3.5 py-1.5'
            }`}
            style={{ backgroundColor: getTeamColor(team) }}
        >
            <span
                className={`rounded-full bg-white/40 flex-shrink-0 ${isXs ? 'w-1 h-1' : 'w-1.5 h-1.5'}`}
            />
            {team}
        </div>
    );
}

interface TeamSplitPillProps {
    teams: string[];
}

// Caps a multi-team pill at about one long single pill so it never grows its row.
const SPLIT_PILL_MAX_WIDTH = 'max-w-[76px]';

// One team renders as a plain xs TeamPill; several share the capped width in equal segments.
export function TeamSplitPill({ teams }: TeamSplitPillProps) {
    const label = teamOwnersLabel(teams);
    return (
        <Tooltip content={label}>
            <div role="img" aria-label={label} className="inline-flex flex-shrink-0">
                {teams.length === 1 ? (
                    <TeamPill team={teams[0]} size="xs" />
                ) : (
                    <span
                        className={`inline-grid ${SPLIT_PILL_MAX_WIDTH} rounded-md overflow-hidden divide-x divide-white/60 text-[10px] font-semibold text-white`}
                        style={{ gridTemplateColumns: `repeat(${teams.length}, minmax(0, 1fr))` }}
                    >
                        {teams.map((team) => (
                            <span
                                key={team}
                                className="truncate px-1 py-0.5 text-center"
                                style={{ backgroundColor: getTeamColor(team) }}
                            >
                                {team}
                            </span>
                        ))}
                    </span>
                )}
            </div>
        </Tooltip>
    );
}
